export default __webpack_public_path__ + "e0e7229cad5fcd6dbea88fb7520ece2f.jpg";